import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from '../context';

const Icon = (props) => {
  const { config } = useContext(ConfigContext);

  let { alt, icon, className, width, height } = props;

  if(typeof width === 'undefined') {
    width = 21;
  }

  if(typeof height === 'undefined') {
    height = 21;
  }

  // Convert icon name to url
  if (icon.indexOf('/') === -1) {
    icon = `${config.studioUrl}web/assets/${icon}.svg?t=${config.resourceTimestamp}`;
  }

  return <img className={className || 'dealers-icon'} src={icon} alt={alt || ''} width={width} height={height} />;
};

Icon.propTypes = {
  alt: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};


export const IconV2 = (props) => {
  const { icon } = props;
  let { className, width, height } = props;

  if(typeof width === 'undefined') {
    width = 21;
  }

  if(typeof height === 'undefined') {
    height = 21;
  }

  switch (props.icon) {
    case 'filter':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={'d-icon-v2 ' + (className || '')}>
          <path d="M19.686187 0H1.31406C.148189 0-.440057 1.414506.385957 2.24056L7.875 9.731163v7.659463c-.000015.378475.163372.738529.448219.987738l2.625 2.296178c.838277.733482 2.176781.150937 2.176781-.987738v-9.95564l7.489248-7.490602C21.438662 1.416187 20.854395 0 19.686188 0zM11.8125 9.1875v10.5l-2.625-2.296875V9.1875l-7.875-7.875h18.375l-7.875 7.875z" fill="var(--icon-color, currentColor)" fillRule="nonzero"/>
        </svg>
      );
    case 'map':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width*1.3} height={height*1.3} className={"d-icon-v2 " + (className || "")} viewBox="0 0 1774.83 1478.05">
          <path fill="var(--icon-color, currentColor)" d="M1769.14,1202.29c-19.33-48.72-47.8-99.85-69.93-148.07-54.46-118.66-106.34-242.96-164.7-359.3-16.82-33.52-31.06-68.13-76.33-55.69l-261.31,118.57-137.41-67.46-45.25,76.91,142.02,69.94,18.82,13.18,113.12,513.86-365.99-175.99v-268c-19.93,8.22-46,9.17-65.86.79l-4.14,2.21v264l-365.99,176.99,114.22-510.76c4.39-9.82,17.13-14.54,26.45-19.55,39.24-21.1,84.11-42.31,124.59-61.44,5.72-2.7,11.02-.47,8.7-8.89-.41-1.49-3.1-1.5-3.88-2.83-13.42-22.97-27.74-46.23-38.11-70.51l-138.96,67.19-263.39-119.82c-44.25-8.73-57.22,21.55-73.33,53.93C157.75,861.78,87.4,1039.71,3.22,1210.29c-10.74,33.17,6.72,49.95,33.2,64.72,125.15,69.81,261.81,126.27,387.02,196.98,20.93,8.38,32.99,6.26,53.52-1.95l412.06-199.76,425.25,204.89c14.61,6.69,27.09.4,40.62-5.19,123.95-69.77,262.03-124.45,384.63-195.37,30.32-17.54,43.89-36.32,29.61-72.3ZM432.16,1376.25l-325.84-166.15,213.88-471.85,227.59,104.39-115.63,533.61ZM1345.17,1376.21l-119.13-532.8,230.06-105.1,212.25,470.68-323.17,167.21Z" />
          <path fill="var(--icon-color, currentColor)" d="M771.84,713.6c27.88,48.56,61.22,115.36,92.7,159.3,8.51,11.87,16.78,16.33,31.7,12.41,13.37-3.51,24.59-32.68,31.56-44.43,41.5-69.99,83.05-140.24,122.72-211.28,39.08-69.99,91.96-156.84,119.15-230.85C1245.24,193.1,1078.84-14.95,863.77.85c-204.34,15.01-331.07,225.56-251.94,414.75,40.83,97.63,106.78,205.32,160.01,297.99ZM736.75,251.82c16.51-55.48,70.33-104.82,128.98-111.02,179.21-18.92,246.88,216.76,95.82,295.82-123.65,64.71-264.8-50.39-224.8-184.8Z" />
        </svg>
      );
    default:
      throw new Error(`Unknown icon: ${props.icon}`);
  }
};

IconV2.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Icon;
